import * as React from 'react';
import Popover from 'react-bootstrap/Popover';
import { OverlayTrigger } from 'react-bootstrap';
import './MyPopover.css';

interface Props {
  content: string;
}

interface State {
}

class MyPopover extends React.Component<Props, State> {

  render() {
    const popover = (
      <Popover id="popover-basic" className="modern-popover">
        <Popover.Header className="modern-popover-header">
          <i className="fas fa-comment-alt me-2"></i>
          Flight Note
        </Popover.Header>
        <Popover.Body className="modern-popover-body">
          <div className="popover-content">
            {this.props.content}
          </div>
        </Popover.Body>
      </Popover>
    );

    const InfoTrigger = () => (
      <OverlayTrigger
        trigger="click"
        placement="left"
        overlay={popover}
        rootClose={true}
        delay={{ show: 50, hide: 0 }}
        popperConfig={{
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                boundary: 'viewport',
              },
            },
          ],
        }}
      >
        <button
          className="btn btn-sm btn-outline-info info-button"
          title="View flight notes"
          type="button"
        >
          <i className="fas fa-info-circle"></i>
        </button>
      </OverlayTrigger>
    );

    return <InfoTrigger />;
  }
}

export default MyPopover